import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from "./context/CartContext";
import HomePage from "./pages/HomePage";
import ProductDetail from "./pages/ProductDetail";
import CategoryPage from "./pages/CategoryPage";
import SearchPage from "./pages/SearchPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentResultPage from "./pages/PaymentResultPage";
import DynamicPage from "./pages/DynamicPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ProfilePage from "./pages/ProfilePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

// Footer Pages
// Removed static pages - now using dynamic CMS pages

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminSlider from "./pages/admin/AdminSlider";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminAddProduct from "./pages/admin/AdminAddProduct";
import AdminEditProduct from "./pages/admin/AdminEditProduct";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminProductSorting from "./pages/admin/AdminProductSorting";
import AdminCollections from "./pages/admin/AdminCollections";
import AdminPages from "./pages/admin/AdminPages";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminSiteSettings from "./pages/admin/AdminSiteSettings";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminDiscounts from "./pages/admin/AdminDiscounts";
import AdminReports from "./pages/admin/AdminReports";
import AdminProfile from "./pages/admin/AdminProfile";
import AdminReviews from "./pages/admin/AdminReviews";
import WhatsAppButton from "./components/WhatsAppButton";
import { useLocation } from "react-router-dom";

function GlobalWhatsApp() {
  const { pathname } = useLocation();
  // Hide on admin routes
  if (pathname.startsWith('/admin')) return null;
  return <WhatsAppButton />;
}

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/products" element={<CategoryPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/siparis-takip" element={<OrderTrackingPage />} />
              <Route path="/order-success/:orderId" element={<OrderSuccessPage />} />
              <Route path="/payment/:orderId" element={<PaymentPage />} />
              <Route path="/payment/success" element={<PaymentResultPage outcome="success" />} />
              <Route path="/payment/fail" element={<PaymentResultPage outcome="fail" />} />
              
              {/* User Auth Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/slider" element={<AdminSlider />} />
              <Route path="/admin/products" element={<AdminProducts />} />
              <Route path="/admin/products/add" element={<AdminAddProduct />} />
              <Route path="/admin/products/edit/:id" element={<AdminEditProduct />} />
              <Route path="/admin/categories" element={<AdminCategories />} />
              <Route path="/admin/sorting" element={<AdminProductSorting />} />
              <Route path="/admin/collections" element={<AdminCollections />} />
              <Route path="/admin/pages" element={<AdminPages />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/discounts" element={<AdminDiscounts />} />
              <Route path="/admin/reports" element={<AdminReports />} />
              <Route path="/admin/profile" element={<AdminProfile />} />
              <Route path="/admin/reviews" element={<AdminReviews />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/settings" element={<AdminSiteSettings />} />
              <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

              {/* Dynamic Pages (CMS) - Must be last */}
              <Route path="/:slug" element={<DynamicPage />} />
            </Routes>
            <GlobalWhatsApp />
          </BrowserRouter>
        </div>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;